/*!
 * Created by Justin K Kazmierczak.
 * 
 * Expands shorthand notation to full names.
 * 
 * For Use In:
 *  Universe Accounts
 * 
 * (c) 2024. Justin K Kazmierczak. All Rights Reserved.
 */

/**
 * Converts C, N, NS, I, S, A, T, F to class, namespace, inner, style, alt, title, fields.
 * This is used to convert shorthand notation in JSON renderers to full names.
 * @typedef {Object} jsonRenderShortHand
 */
const jsonRenderShortHand = {
    "class": ["c"],
    "namespace": ["n", "ns"],
    "inner": ["i"],
    "style": ["s"],
    "alt": ["a"],
    "title": ["t"],
    "fields": ["f"]
}; module.exports.jsonRenderShortHand = jsonRenderShortHand;

var expand = require("./functions/shorthand.js").function;
module.exports.expand = expand;